"use client";
import { motion, Variants } from "framer-motion";
import Image from "next/image";
const containerVariants: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2, // 자식 요소 하나씩 0.2초 간격으로 등장
    },
  },
};

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

export default function WebusNotificationSection() {
  const items = [
    {
      num: 1,
      title: "탑승 보장",
      text: "교통약자 승·하차 정류장을 기사님에게 미리 알려 저상버스 탑승이 보장됩니다.",
    },
    {
      num: 2,
      title: "시간 단축",
      text: "버스 기사님이 교통약자 탑승 여부를 미리 확인할 수 있어, 승·하차 시 리프트 설치를 위한 정차 시간이 단축됩니다.",
    },
    {
      num: 3,
      title: "안내 방송",
      text: "안내 방송으로 승·하차 상황을 알리고, 자연스럽게 자리 양보를 유도해 불편을 최소화합니다.",
    },
  ];
  return (
    <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-0 mt-[-20px] md:mt-0 md:py-20">
      <motion.div
        className="text-center"
        initial={{ opacity: 0, y: 40 }} // 처음에는 살짝 아래에서 시작, 투명
        whileInView={{ opacity: 1, y: 0 }} // 화면에 들어오면 나타나고 원래 위치로
        viewport={{ once: true, amount: 0.5 }} // 한번만, 요소 절반 정도 보이면 실행
        transition={{ duration: 0.9, ease: "easeOut" }} // 부드러운 모션
      >
        <p
          className="text-[26px] sm:text-3xl md:text-5xl text-black-almostBlack md:mt-14 md:mb-10 sm:mt-10 sm:mb-5 mt-8 mb-5 leading-9 sm:leading-10 md:leading-16"
          style={{ fontFamily: '"pre-Bold", sans-serif' }}
        >
          더 안전한 승하차를 위해,
          <br />
          미리 알려주는 탑승정보
        </p>
        <p
          className="text-base text-midGray-50 md:text-2xl text-light-10 tracking-tighter md:leading-10 sm:leading-7 leading-[26px]"
          style={{ fontFamily: '"pre-Medium", sans-serif' }}
        >
          탑승 요청 후, 교통약자의 정보가
          <br />
          버스 기사님의 단말기로 실시간 전달됩니다.
        </p>
      </motion.div>

      {/* 그리드 */}
      <motion.div
        className="flex gap-4 mt-20 md:mt-30 items-stretch lg:flex-row flex-col"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
      >
        {/* 왼쪽 */}
        <motion.div
          className="bg-[#2782FF] flex-1 flex flex-col  rounded-3xl px-8 md:px-14"
          variants={itemVariants}
        >
          <div className="flex flex-col w-full h-full">
            <div className="relative w-full h-38 sm:h-48 md:h-58 rounded-b-[12px] flex-none">
              <div className="w-full h-full rounded-b-[24px] overflow-hidden relative">
                <Image
                  src="/assets/images/page/service/webus/device.png"
                  alt="device"
                  fill
                  className="object-cover"
                />
              </div>

              {/* 앱솔루트 라벨 */}
              <div
                className="absolute z-10 bg-black right-[-14px] md:right-[-22px] bottom-[-24px] text-white flex items-center px-3 md:px-4 py-3 rounded-2xl"
                style={{
                  boxShadow: "8px 14px 10.3px rgba(110,110,110,0.26)",
                }}
              >
                <div className="relative w-6 h-6 md:w-8 md:h-8 mr-2">
                  <Image
                    src="/assets/images/page/service/webus/voiceIcon.svg"
                    alt="device"
                    fill
                    className="object-contain"
                  />
                </div>
                <span
                  className="text-base md:text-xl tracking-tight leading-5 md:leading-7"
                  style={{ fontFamily: '"pre-Medium", sans-serif' }}
                >
                  음성안내
                </span>
              </div>
            </div>

            {/* 텍스트 영역: 남은 높이 채움 */}
            <div className="md:self-stretch px-0 md:px-4 mt-0 md:mt-3 pb-12 md:pb-14 flex-1 flex flex-col justify-start">
              <p
                className="text-2xl md:text-4xl text-white leading-9 md:leading-13 tracking-tight mt-8 md:mt-10"
                style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
              >
                버스기사 단말기에
                <br />
                교통약자 탑승 요청 알림
              </p>
              <p
                className="text-light-10 text-base md:text-xl tracking-tight leading-6 md:leading-9 mt-4 md:mt-6 "
                style={{ fontFamily: '"pre-Medium", sans-serif' }}
              >
                “다음 정류장에서 교통 약자 탑승을 위해
                <br /> 저상버스 리프트가 사용 될 예정입니다.
                <br /> 원활한 탑승을 위해 통로 확보를 부탁드립니다.“
              </p>
            </div>
          </div>
        </motion.div>

        {/* 오른쪽 2~4 */}
        <div className="flex flex-col gap-4 flex-1 h-full self-stretch">
          {/* h-full 유지 */}
          {items.map((item) => (
            <motion.div
              key={item.num}
              className="flex flex-col items-start px-5 md:px-8 py-6 md:py-10 rounded-3xl w-full bg-[#F3F7FA] flex-none" // 기본: 내용 높이 따름
              variants={itemVariants}
            >
              <div className="flex items-center mb-2 md:mb-1">
                <p
                  className="md:w-8 md:h-8 w-6 h-6 rounded-full flex justify-center items-center bg-[#0075FF] text-white text-sm md:text-xl leading-6 tracking-tighter"
                  style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
                >
                  {item.num}
                </p>
                <p
                  className="ml-2 md:ml-3 text-base md:text-xl text-black-300 tracking-tighter"
                  style={{ fontFamily: '"pre-SemiBold", sans-serif' }}
                >
                  {item.title}
                </p>
              </div>

              <p
                className="text-[15px] md:text-lg leading-6 md:leading-8 tracking-tight text-[#818597] break-keep ml-8 md:ml-11"
                style={{ fontFamily: '"pre-Regular", sans-serif' }}
              >
                {item.text}
              </p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
}
